import { useMemo } from "react";

import { SEO_FIELDS_SLUG } from "common/SeoFields/constants";
import { WYSIWYG_SLUG } from "common/WYSIWYG/constants";
import { GEO_SLUG, POSITION_SLUG, PROGRAM_CARD_SLUG } from "../constants";
import { FAQ_SLUG } from "common/Faq/constants";

export function useProgramData(state: any, isPut: boolean = false) {
  return useMemo(() => {
    const data = {
      type: "program",
      seo_fields: state[SEO_FIELDS_SLUG],
      ...state[POSITION_SLUG],
      ...state[PROGRAM_CARD_SLUG],
      ...state[GEO_SLUG],
      [FAQ_SLUG]: JSON.stringify(state[FAQ_SLUG][FAQ_SLUG]),
      body: state[WYSIWYG_SLUG][WYSIWYG_SLUG],
    };

    // @ts-ignore
    if (isPut) data["_method"] = "PUT";

    return data;
  }, [state]);
}
